export default "__VITE_ASSET__BvM$ljts__"